import { c as _c } from "react/compiler-runtime";
import { visibleData } from '@lib/tools/helpers/constants';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import style from './WhiteBoxGeneral.module.scss';
const WhiteBoxList = t0 => {
  const $ = _c(4);
  const {
    isMobile
  } = t0;
  let t1;
  if ($[0] !== isMobile) {
    t1 = visibleData.map(item => {
      const itemClass = isMobile ? style.item : `item_${item.id}`;
      return <SafeHtmlRenderer key={item.id} tag="li" className={style[itemClass]} content={item.description} />;
    });
    $[0] = isMobile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className={style.list}>{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default WhiteBoxList;